import { render, staticRenderFns } from "./orden_compra_pendiente.vue?vue&type=template&id=6d493ec9&"
import script from "./orden_compra_pendiente.vue?vue&type=script&lang=js&"
export * from "./orden_compra_pendiente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports